function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("g", {
  id: "analytics-icon",
  transform: "translate(1.000000, 1.000000)",
  stroke: "#FF0026",
  strokeWidth: 2.16304348
}, React.createElement("ellipse", {
  id: "Oval",
  cx: 26.0947177,
  cy: 2.59782609,
  rx: 2.56932605,
  ry: 2.47826087
}), React.createElement("ellipse", {
  id: "Oval",
  cx: 9.83358834,
  cy: 6.2826087,
  rx: 2.56932605,
  ry: 2.47826087
}), React.createElement("ellipse", {
  id: "Oval",
  cx: 2.73413479,
  cy: 19.4021739,
  rx: 2.56932605,
  ry: 2.47826087
}), React.createElement("ellipse", {
  id: "Oval",
  cx: 19.8742441,
  cy: 16.4021739,
  rx: 2.56932605,
  ry: 2.47826087
}), React.createElement("path", {
  d: "M21.0462174,14.2065217 L24.8663995,5.09782609",
  id: "Shape"
}), React.createElement("path", {
  d: "M4.07514268,17.2826087 L8.43623558,8.35869565",
  id: "Shape"
}), React.createElement("path", {
  d: "M18.0599393,14.6630435 L11.6817001,8.35869565",
  id: "Shape"
})));

var SvgAnalyticsIcon = function SvgAnalyticsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "31px",
    height: "24px",
    viewBox: "0 0 31 24",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAnalyticsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/analytics-icon.16257b7a.svg";
export { ForwardRef as ReactComponent };